import { useEffect, useRef, useState } from "react";

interface AnimatedPriceProps {
  value: string;
  className?: string;
  children?: React.ReactNode;
}

const AnimatedPrice = ({ value, className = "", children }: AnimatedPriceProps) => {
  const [animate, setAnimate] = useState(false);
  const prevValue = useRef(value);

  useEffect(() => {
    if (prevValue.current !== value) {
      prevValue.current = value;
      setAnimate(true);
      const timer = setTimeout(() => setAnimate(false), 300);
      return () => clearTimeout(timer);
    }
  }, [value]);

  return (
    <span
      className={`inline-block transition-transform duration-300 ease-out ${
        animate ? "scale-110" : "scale-100"
      } ${className}`}
    >
      {value}
      {children}
    </span>
  );
};

export default AnimatedPrice;
